import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import Swal from 'sweetalert2'
import { queryClient } from "../../..";

export default async function deleteProduto(ProdutoId: number) {

  console.log('vai excluir o produto: ', ProdutoId)

  return await api.delete(URLS.PRODUTO_ID_API.replace('id',ProdutoId.toString()))
  .then((response) => {
    Swal.fire({
      title: 'Sucesso',
      text: 'Produto apagado com sucesso!',
      icon: 'success',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#349946',
      allowOutsideClick: false
    })
    queryClient.invalidateQueries();
  })
  .catch((err) => {
    Swal.fire({
      title: 'Ocorreu um erro',
      text: err.response.data.message,
      icon: 'error',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#F27474',
      allowOutsideClick: false
    })
  })
}